import { LinkLikeButton } from './link-like-button';
export default LinkLikeButton;
